/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Mechanical_Engineering25Inputs */

const en__field_enum_tuda_mechanical_engineering25 = /** @type {(inputs: _Field_Enum_Tuda_Mechanical_Engineering25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mechanical Engineering`)
};

const de__field_enum_tuda_mechanical_engineering25 = /** @type {(inputs: _Field_Enum_Tuda_Mechanical_Engineering25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maschinenbau`)
};

/**
* | output |
* | --- |
* | "Mechanical Engineering" |
*
* @param {_Field_Enum_Tuda_Mechanical_Engineering25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_mechanical_engineering25 = /** @type {((inputs?: _Field_Enum_Tuda_Mechanical_Engineering25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Mechanical_Engineering25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_mechanical_engineering25(inputs)
	return de__field_enum_tuda_mechanical_engineering25(inputs)
});
export { _field_enum_tuda_mechanical_engineering25 as "_field_enum_TUDA_MECHANICAL_ENGINEERING" }